'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearsAfter;


// WEBPACK FOOTER //
// ./~/sugar-date/number/yearsAfter.js